import React, { Component } from "react";
import { withCars } from "../../../../shared/containers/containerCars";
import { withFilterCars } from "../../../../shared/containers/containerFilterCars";
import { states } from "../../../../reducers/queriesStates";
import Preloader from "../../../../shared/items/static/preloader";
import Notification from "../../../../shared/items/static/notification";
import styles from "./userUnitBar.module.scss";
import UserUnitsListItems from "./UserUnitListItems";
import { withWinterMaintence } from "../../../../shared/containers/containerWinterMaintence";
import { withAuth } from "../../../../shared/containers/containerAuth";
import { unitFilterService } from "../../../sections/cars/unitFilterService";

class UserUnitsList extends Component {
  componentDidMount() {
    unitFilterService.didMount(this.props);
  }

  componentWillUnmount() {
    const { onStopConnect, connectionSR } = this.props;

    if (!!connectionSR) onStopConnect(connectionSR);

    unitFilterService.clearTimeoutConnection();
  }

  componentDidUpdate(prevProps) {
    unitFilterService.didUpdate(prevProps, this.props);
  }

  render() {
    const { handleScrollTo, listUnits, dataStateUnits } = this.props;

    if (dataStateUnits === states.REQUEST) {
      return (
        <React.Fragment>
          <div className={styles.userUnitsList_wrapper}>
            <div className={styles.container_preloader}>
              <Preloader />
            </div>
          </div>
        </React.Fragment>
      );
    }

    if (listUnits.length === 0) {
      return (
        <React.Fragment>
          <div className={styles.userUnitsList_wrapper}>
            <Notification type="warning">
              <p>По данным параметрам поиска автомобили не найдены.</p>
            </Notification>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className={styles.userUnitsList_wrapper}>
          <div className={styles.userUnitsList}>
            <UserUnitsListItems data={listUnits} handleScrollTo={handleScrollTo} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withAuth(withWinterMaintence(withCars(withFilterCars(UserUnitsList))));
